import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './style.module.less';
const ContextMenuLabel = ({ label, shortcut }) => {
    return (_jsxs("button", { type: "button", className: styles.contextMenuLabel, children: [_jsx("span", { children: label }), shortcut === undefined ? null : (_jsx("span", { className: styles.shortcut, children: shortcut }))] }));
};
export default ContextMenuLabel;
